import React, { useEffect } from "react";
import "./MobileMapFullScreen.scss";

const MobileMapFullScreen = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="map-modal">
      <div className="map-modal__overlay" onClick={onClose} />

      <div className="map-modal__container">
        <button
          className="map-modal__close-btn"
          onClick={onClose}
          aria-label="Close map"
        >
          &times;
        </button>

        <div className="map-modal__content">{children}</div>
      </div>
    </div>
  );
};

export default MobileMapFullScreen;
